"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var EmailIcon = function EmailIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.99984 1.66675C5.40484 1.66675 1.6665 5.40508 1.6665 10.0001C1.6665 14.5951 5.40484 18.3334 9.99984 18.3334C10.9709 18.3334 11.9572 18.1381 12.9408 17.7512C13.3688 17.5828 13.5366 17.0793 13.333 16.6669C13.1293 16.2541 12.6308 16.09 12.1992 16.2504C11.4549 16.5269 10.7179 16.6667 9.99984 16.6667C6.324 16.6667 3.33317 13.6759 3.33317 10.0001C3.33317 6.32425 6.324 3.33341 9.99984 3.33341C13.6757 3.33341 16.6665 6.32425 16.6665 10.0001V10.8334C16.6665 11.4101 16.4057 12.5001 15.4165 12.5001C14.2532 12.5001 14.1715 10.9842 14.1665 10.8334V6.66675H12.4998V6.68758C11.8015 6.15925 10.9415 5.83342 9.99984 5.83342C7.70234 5.83342 5.83317 7.70258 5.83317 10.0001C5.83317 12.2976 7.70234 14.1667 9.99984 14.1667C11.2082 14.1667 12.2898 13.6409 13.0515 12.8159C13.4882 13.5576 14.2248 14.1667 15.4165 14.1667C17.3107 14.1667 18.3332 12.4492 18.3332 10.8334V10.0001C18.3332 5.40508 14.5948 1.66675 9.99984 1.66675ZM9.99984 12.5001C8.6215 12.5001 7.49984 11.3784 7.49984 10.0001C7.49984 8.62175 8.6215 7.50008 9.99984 7.50008C11.3782 7.50008 12.4998 8.62175 12.4998 10.0001C12.4998 11.3784 11.3782 12.5001 9.99984 12.5001Z",
    fill: color
  }));
};

var _default = EmailIcon;
exports.default = _default;